import React, { Component } from "react";
import { Button, Grid } from "@material-ui/core";

import EditMaterial from "./EditMaterial";
import AddMaterial from "./AddMaterial";
// import { blue } from "@material-ui/core/colors";
import { Add } from "@material-ui/icons";
import Style from "./style.module.scss";
import PropTypes from "prop-types";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import {
  addMaterial,
  // getMaterial,
  updateMaterial,
  deleteMaterial,
  getStore,
} from "../../Redux/materialRedux/materialAction";
import Notifications from "react-notification-system-redux";
import axios from "axios";
// import Typography from "material-ui/styles/typography";
// import { each } from "lodash";

class Display extends Component {
  constructor(props) {
    super(props);
    const role = global.config.secureStorage.getItem("role");
    const editRoles = ["purchase_manager", "project_manager", "super_admin"];
    const isEditable = editRoles.find(item => item == role) ? true : false;
    this.state = {
      materialName: "",
      materialLimit: "",
      materialQuantity: "",
      materialRate: "",
      materialUnit: "",
      materialAmount: "",
      editMaterialId: "",
      activity: "",
      allMaterials: [],
      storeData: [],
      isCreateNewMaterial: false,
      isModifyMaterial: false,
      isEditable: isEditable,
      libraryData: [],
      isEditMaterial: false,
      editId: "",
      activities: [],
      activityIndex: -1,
      subAccIndex: -1,
    };
  }
  columns = [
    {
      name: "materialName",
      label: "Material",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "activity",
      label: "Activity",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "materialQuantity",
      label: "Quantity",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "materialUnit",
      label: "Unit",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "materialRate",
      label: "Rate",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "materialAmount",
      label: "Amount",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "Edit",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <button
              onClick={() => {
                this.toggleEditMaterial(tableMeta);
              }}
            >
              Edit
            </button>
          );
        },
      },
    },
    {
      name: "Delete",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <button onClick={() => this.deleteMaterial(tableMeta.rowIndex)}>
              Delete
            </button>
          );
        },
      },
    },
  ];
  handleMaterialChange = (event,newValue) => {
    console.log(newValue)
    this.setState({ materialName: newValue });
  };
  async getLibraryData() {
    let projectId = await global.config.secureStorage.getItem("projectId");
    try {
      const res = await axios.post(
        `${global.config.backendURL}/library/getLibrary`,
        {
          projectId: projectId,
        }
      );
      this.setState({ libraryData: res.data });
    } catch (err) {
      console.log(err);
    }
  }
  async componentDidMount() {
    await this.getLibraryData();
    // await this.props.getMaterial();
    await this.props.getStore();
    this.getActivities()
    if (!this.props.loading) {
      this.setState({
        allMaterials: this.props.material.data,
        storeData: this.props.material.storeData,
      });
    }
  }

  deleteMaterial = async id => {
    let singleMaterial = [...this.state.libraryData];
    singleMaterial = singleMaterial[id];
    try {
      const res = await axios.post(
        `${global.config.backendURL}/library/deleteMaterial/${singleMaterial._id}`
      );
      let tempData = this.state.libraryData;
      tempData.splice(id, 1);
      console.log(tempData);
      this.setState({
        materialName: "",
        materialQuantity: "",
        materialRate: "",
        materialUnit: "",
        materialAmount: "",
        activity: "",
        libraryData: tempData,
      });
    } catch (err) {
      console.log(err);
    }
  };

  toggleEditMaterial = tableMeta => {
    let singleMaterial = [...this.state.libraryData];
    singleMaterial = singleMaterial[tableMeta.rowIndex];
    console.log("rowIndex" + tableMeta.rowIndex);
    console.log(singleMaterial);
    let new_task=[];
    let acc_index;
    let task_index;
    let subacc_index;
    console.log("this state activites is ",this.state.activities,singleMaterial)
    this.state.activities.forEach( async (acc,accIndex) =>{
      console.log("equaliazing them ",acc.title,singleMaterial.activity)
            if(acc.title === singleMaterial.activity)
            {
              console.log("acc ndiex is ",accIndex)
              acc_index=accIndex
              const subprojectId = global.config.secureStorage.getItem("subprojectId");
                 acc.content.forEach(async  (subacc,subIndex)=>{
                  if(subacc.subTitle=== singleMaterial.subactivity)
                  {
                    console.log("indexes are",subIndex)
                    subacc_index=subIndex
                    const res = await axios.get(
                      `${global.config.backendURL}/activities/getActivity?activity=${subacc.link}&subprojectId=${subprojectId}`
                    );
                    let new_taskCost;
                    res.data.forEach((task,taskindex)=>{
                      if(singleMaterial.taskName===task.name)
                      {
                        new_taskCost=task.taskCost
                        task_index=taskindex
                        return
                      }
                    })
                    this.setState({
                      taskList:res.data,
                      taskName:  singleMaterial.taskName + ";" + task_index,
                      taskCost:new_taskCost,
                      activityIndex:acc_index,
                      subAccIndex:subacc_index,
                    })
                  }
                 })
            }
    })
    console.log("single materias is ",singleMaterial,tableMeta.rowIndex)
    if (!this.state.isEditMaterial) {
      this.setState({
        editId: singleMaterial._id,
        materialName: singleMaterial.materialName,
        materialQuantity: singleMaterial.materialQuantity,
        materialRate: singleMaterial.materialRate,
        materialAmount:
          singleMaterial.materialRate * singleMaterial.materialQuantity,
        materialUnit: singleMaterial.materialUnit,
        activity: singleMaterial.activity + ";" + acc_index,
        subAccName: singleMaterial.subactivity + ";" + subacc_index,
        activityIndex:acc_index,
        subAccIndex:subacc_index,
        isEditMaterial: !this.state.isEditMaterial,
      });
    }
  };

  handleChange = (event, value = null) => {
    if (value === null) {
      this.setState({
        [event.target.name]: event.target.value,
      });
    } else {
      this.setState({
        materialName: value,
      });
    }
  };

  handleActivity = event => {
    this.setState({
      activity: event.target.value,
      activityIndex: event.target.value.split(";")[1],
      taskCost:"",
      taskName:"",
      taskList:"",
      subAccName:"",
      subAccIndex:""
    });
  };
  getActivities = async () => {
    let projectId = await global.config.secureStorage.getItem("projectId");
    const response = await axios.get(
      `${global.config.backendURL}/activities/getDefaultActivities/${projectId}`
    );
    // if(projectType === "Infrastructure"){
    //   const mainActivities = response.data.data.map((mainAct,index)=>{
    //     console.log(mainAct)
    //     return {
    //       id: index,
    //       title : maisnAct.name,
    //       activities : mainAct.data
    //     };
    //   });
    //   setMainActivities(mainActivities);
    // }
    // else{
    //   setActivities(response.data.data[0].data);
    // }
    let final = [];
    response.data.data.forEach(element => {
      if (element.visibility) final.push(element);
    });
    this.setState({
      activities: final,
    });
  };
  // handleMainActivity = event => {
  //   console.log(event)
  //   this.setState({ mainActivity: event.target.value});
  // };
  toggleCreateNewMaterial = () => {
    this.setState({
      subAccName: "",
      taskList: [],
      taskName: "",
      taskCost: "",
      activityIndex: -1,
      subAccIndex: -1,
      materialName: "",
      materialQuantity: "",
      materialRate: "",
      materialAmount: "",
      materialUnit: "",
      activity: "",
      isCreateNewMaterial: !this.state.isCreateNewMaterial,
    });
  };

  updateMaterial = async event => {
    event.preventDefault();

    let projectId = await global.config.secureStorage.getItem("projectId");

    const finalEquipment = {
      projectId,
      materialName: this.state.materialName,
      materialQuantity: this.state.materialQuantity,
      materialRate: this.state.materialRate,
      materialAmount: this.state.materialRate * this.state.materialQuantity,
      materialUnit: this.state.materialUnit,
      activity: this.state.activity.split(";")[0],
      _id: this.state.editId
    };

    // const num = Number(this.state.libraryData);
    let tempData = [...this.state.libraryData];
    if (this.state.editId != undefined) {
      try {
        const res = await axios.post(
          `${global.config.backendURL}/library/editLibrary/${this.state.editId}`,
          {
            ...finalEquipment,
          }
        );
      } catch (err) {
        console.log(err);
      }
      let objIndex = tempData.findIndex(obj => obj._id == this.state.editId);
      tempData[objIndex] = finalEquipment;

      this.setState({
        editId: "",
        materialName: "",
        materialQuantity: "",
        materialRate: "",
        materialUnit: "",
        materialAmount: "",
        activity: "",
        isEditMaterial: !this.state.isEditMaterial,
        libraryData: tempData,
        subactivity: "",
        taskName: "",
        taskCost: "",
        taskList:"",
      });
    }
  };

  saveMaterial = async event => {
    event.preventDefault();
    let projectId = await global.config.secureStorage.getItem("projectId");
    const finalMaterial = {
      projectId,
      materialName: this.state.materialName,
      materialQuantity: this.state.materialQuantity,
      materialRate: this.state.materialRate,
      materialAmount: this.state.materialRate * this.state.materialQuantity,
      materialUnit: this.state.materialUnit,
      activity: this.state.activity.split(";")[0]
    };
    try {
      const res = await axios.post(
        `${global.config.backendURL}/library/addToLibrary`,
        {
          ...finalMaterial,
        }
      );
    } catch (err) {
      console.log(err);
    }
    let tempData = [...this.state.libraryData, finalMaterial];
    console.log(tempData);
    this.setState({
      materialName: "",
      materialQuantity: "",
      materialRate: "",
      materialUnit: "",
      materialAmount: "",
      activity: "",
      isCreateNewMaterial: !this.state.isCreateNewMaterial,
      libraryData: tempData
    });
    window.location.reload();
  };
  render() {
    const { isCreateNewMaterial, isEditMaterial } = this.state;
    if (isCreateNewMaterial) {
      return (
        <AddMaterial
          storeData={this.props.material.storeData}
          handleChange={this.handleChange}
          materialName={this.state.materialName}
          materialQuantity={this.state.materialQuantity}
          materialRate={this.state.materialRate}
          materialUnit={this.state.materialUnit}
          materialAmount={this.state.materialAmount}
          activity={this.state.activity}
          saveMaterial={this.saveMaterial}
          toggleCreateNewMaterial={this.toggleCreateNewMaterial}
          handleActivity={this.handleActivity}
          handleMaterialChange={this.handleMaterialChange}
          activityIndex={this.state.activityIndex}
          handleSubActivity={this.handleSubActivity}
          activities={this.state.activities}
          taskList={this.state.taskList}
          taskName={this.state.taskName}
          handleTaskChange={this.handleTaskChange}
          subAccName={this.state.subAccName}
          taskCost={this.state.taskCost}
        />
      );
    }
    if (isEditMaterial) {
      return (
        <EditMaterial
          storeData={this.props.storeData}
          handleChange={this.handleChange}
          materialName={this.state.materialName}
          materialQuantity={this.state.materialQuantity}
          materialRate={this.state.materialRate}
          materialUnit={this.state.materialUnit}
          materialAmount={this.state.materialAmount}
          activity={this.state.activity}
          updateMaterial={this.updateMaterial}
          toggleEditMaterial={this.toggleEditMaterial}
          handleActivity={this.handleActivity}
          handleMaterialChange={this.handleMaterialChange}
          activityIndex={this.state.activityIndex}
          handleSubActivity={this.handleSubActivity}
          activities={this.state.activities}
          taskList={this.state.taskList}
          taskName={this.state.taskName}
          handleTaskChange={this.handleTaskChange}
          subAccName={this.state.subAccName}
          taskCost={this.state.taskCost}
        />
      );
    }
    return (
      <div>
        {this.props.notifications && (
          <Notifications notifications={this.props.notifications} />
        )}
        {this.state.isEditable && (
          <section className={Style.button__display}>
            <Button
              onClick={this.toggleCreateNewMaterial}
              startIcon={<Add />}
              size="large"
            >
              Add Material
            </Button>
          </section>
        )}
        <Grid container justify="center">
          <Grid item>
            <MUIDataTable
              title={`Material`}
              data={this.state.libraryData}
              columns={this.columns}
              options={{
                selectableRows: "none",
                responsive: "simple",
                pagination: false,
                download: false,
                viewColumns: false,
                filter: true,
                print: false,
              }}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

Display.propTypes = {
  material: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    material: state.materialReducer,
    notifications: state.notifications,
    success: state.materialReducer.success,
    loading: state.materialReducer.loading,
    data: state.materialReducer.data,
    storeData: state.materialReducer.storeData,
  };
};

export default connect(mapStateToProps, {
  addMaterial,
  // getMaterial,
  updateMaterial,
  deleteMaterial,
  getStore,
})(Display);
